import { colors, fonts } from '../../theme';

// Top center of the video, as high as the sound button (same pill as the app).
const pill = {
  position: 'absolute',
  top: 14,
  left: '50%',
  transform: 'translateX(-50%)',
  height: 36,
  px: 1.75,
  display: 'inline-flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  borderRadius: '18px',
  border: `1px solid ${colors.border}`,
  backgroundColor: 'rgba(18, 18, 18, 0.85)',
  fontFamily: fonts.text,
  fontSize: 13,
  fontWeight: 800,
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
};

// Border of the "in competition" pill: the light of NeonBorder runs on it (as in the app).
export const COMPETITION_BORDER = 1.5;

const styles = {
  top: {
    ...pill,
    color: colors.top,
  },
  // Solid background (like the app): the light only shows on the border.
  competition: {
    ...pill,
    border: `${COMPETITION_BORDER}px solid ${colors.border}`,
    backgroundColor: '#121212',
    color: colors.text,
  },
};

export default styles;
